import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { Button, Card, Container, Group, Loader, Paper, Stack, Text } from '@mantine/core';
import queryString from 'querystring';
import useUserData from '@features/common/hooks/use-user-data';
import { GuestCountSelector } from '@features/booking/components/GuestsCount/GuestCountSelector';
import { PriceSummary } from '@features/booking/components/Summary/PriceSummary';
import { PricePerNight } from '@features/booking/components/PricePerNight';
import { BookingRangeSelector } from '@features/booking/components/RangeSelector/BookingRangeSelector';
import { AuthModal } from '@features/booking/components/AuthModal/AuthModal';
import { BookingSuccessModal } from '@features/booking/components/BookingSuccessModal/BookingSuccessModal';
import useIsMounted from '@hooks/use-is-mounted';
import { usePropertyState } from "@core/providers/PropertyStateProvider";
import { useBookingState } from "@core/providers/BookingStateProvider";

import { useGetPricesQuery } from '../../../generated/graphql';
import useStyles from './BookingCard.styles';
import { MinimumNightsBadge } from "@features/booking/components/MinimumNights/MinimumNightsBadge";


export const BookingCard: React.FC = () => {

    const mountLock = useRef(true);
    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
    const [isBookingSuccessModalVisible, setIsBookingSuccessModalVisible] = useState(false);

    const { propertyDetailsData } = usePropertyState();
    const {
        setPropertyCalendarPrices,
        createBookingPaymentSession,
        isReadyToBook,
    } = useBookingState();

    const { isUser } = useUserData();

    // CALLS
    const { data, loading } = useGetPricesQuery({
        variables: {
            smoobuId: propertyDetailsData.smoobu_id, propertyId: propertyDetailsData.id
        },
        onCompleted: (query) => {

            setPropertyCalendarPrices({
                dxbstay: query.getPrices?.dxbstay, smoobu: query.getPrices?.smoobu
            });

            //setSmoobuPropId(propertyDetailsData.smoobu_id);
            //setDXBPropId(propertyDetailsData.id);
        }
    })

    const router = useRouter();
    const [bookingLoading, setBookingLoading] = useState(false);

    const submitBooking = () => {

        // MAKE SURE USER IS LOGGED IN
        // IF NOT SHOW HIM/HER THE AUTH MODEL
        if (!isUser()) {
            setIsAuthModalVisible(true);
        } else {

            // AND HIS PASSPORT COPY IS WITH US BEFORE BOOKING
            /*isPassportApproved()
                .then((status) => {
                    if (status) {
                        setBookingLoading(true);

                        createBookingPaymentSession()
                            .then((res) => {

                                // console.log(res, 'BookingPaymentSession :: DONE')

                                setBookingLoading(false);

                                if (res.status) {
                                    router.push(res.url).catch(console.error)
                                }

                            })
                            .catch(() => {
                                setBookingLoading(false);
                            });
                    }
                }).catch(() => console.error('User profile is not complete'))*/

            // NOT CHECKING FOR PASSPORT
            setBookingLoading(true);

            createBookingPaymentSession()
                .then((res) => {

                    // console.log(res, 'BookingPaymentSession :: DONE')

                    setBookingLoading(false);

                    if (res.status) {
                        router.push(res.url).catch(console.error)
                    }

                })
                .catch(() => {
                    setBookingLoading(false);
                });

        }

    }

    useEffect(() => {

        if (mountLock.current) {
            mountLock.current = false;

            // DO NOT CHANGE ROUTER RELATED STUFF - CAUSING UN KNOWN BEHAVIOUR
            const path = router.asPath.split('?');

            if (path.length) {

                // const slug = path[0];
                const query = path[1]; //booking=true booking=false
                const queryStr = queryString.parse(query);

                if (queryStr.booking === 'true') {
                    setIsBookingSuccessModalVisible(true);
                }

                // IF USER PRESSES BACK BUTTON TO COME BACK TO THIS PAGE
                if (queryStr.booking === 'false') {
                    // USER CAME BACK BY PAYMENT PAGE
                }
            }

            // console.log('BOOKING CARD PATH', "-")
        }

    }, []);

    return isMounted && (
        <Container p={0}>

            {
                isAuthModalVisible &&
                <AuthModal
                    open={isAuthModalVisible}
                    onClose={() => {
                        setIsAuthModalVisible(false);
                    }}/>
            }

            {
                isBookingSuccessModalVisible &&
                <BookingSuccessModal
                    open={isBookingSuccessModalVisible}
                    onClose={() => {
                        setIsBookingSuccessModalVisible(false);
                    }}/>
            }

            {loading && <Paper mt={30} className={classes.progress}><Loader color="#f39c12" variant="dots" size="sm"/></Paper>}
            {/*{loading && <Progress color="#f39c12" radius="xl" size="xl" value={100} striped={false} animate={false}/>}*/}
            {data?.getPrices &&

                <Paper className={classes.paper}>
                    <Card>

                        <Card.Section p={20}>

                            <Group>

                                <PricePerNight/>

                                <MinimumNightsBadge/>

                            </Group>

                            {
                                !isReadyToBook() &&
                                <Text className={classes.readyToBookText} color="orange" mt={10} mb={-8}>Select dates to show price</Text>
                            }

                        </Card.Section>

                        <Card.Section pt={0} pb={0} p={20}>

                            <Stack>

                                <BookingRangeSelector/>

                                <GuestCountSelector />

                            </Stack>

                        </Card.Section>

                        <Card.Section pt={0} p={20}>

                            <Button
                                className={classes.bookNowButton}
                                disabled={!isReadyToBook()}
                                loading={bookingLoading}
                                // variant="gradient"
                                style={{ fontWeight: 400 }}
                                radius="xs"
                                mt="xl"
                                fullWidth={true}
                                onClick={() => submitBooking()}
                            >
                                Book Now
                            </Button>

                        </Card.Section>

                        {
                            isReadyToBook() &&
                            <Card.Section pt={0} p={20}>
                                <PriceSummary/>
                            </Card.Section>
                        }


                    </Card>
                </Paper>
            }

        </Container>
    )

}
